import { render, staticRenderFns } from "./BorderedInput.vue?vue&type=template&id=a9a1a908"
import script from "./BorderedInput.vue?vue&type=script&lang=js"
export * from "./BorderedInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports